import { nameRegex } from "@oefr/utils/regex"
import { z } from "zod"

type GetNameSchemaOptions = {
    requiredErrorMessage: string
    invalidErrorMessage: string
}

export function getNameSchema({ requiredErrorMessage, invalidErrorMessage }: GetNameSchemaOptions) {
    return z
        .string({ error: requiredErrorMessage })
        .trim()
        .transform((s) => s.replace(/\s+/g, " ")) // collapse consecutive whitespace into a single space
        .pipe(z.string().regex(nameRegex, invalidErrorMessage))
}
